"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GenericFormController = /** @class */ (function () {
    function GenericFormController($uibModalInstance, countriesApi, requestFormService, servicePage) {
        this.$uibModalInstance = $uibModalInstance;
        this.countriesApi = countriesApi;
        this.requestFormService = requestFormService;
        this.servicePage = servicePage;
        this.isSubmitting = false;
        this.isFormValid = true;
        this.init();
    }
    GenericFormController.prototype.$onInit = function () {
    };
    GenericFormController.prototype.init = function () {
        var _this = this;
        this.model = {
            page: this.servicePage,
            service: this.servicePage.title
        };
        this.countriesApi.query(null, function (countries) {
            _this.countries = countries;
        });
    };
    GenericFormController.prototype.submit = function () {
        var _this = this;
        if (!this.form.$valid) {
            this.isFormValid = false;
            return;
        }
        this.isFormValid = true;
        this.isSubmitting = true;
        // assign service description page title to the model
        this.model.page = this.servicePage;
        this.requestFormService.postForm(this.model).promise.then(function () {
            _this.$uibModalInstance.close();
        }).finally(function () { return _this.isSubmitting = false; });
    };
    GenericFormController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss();
    };
    return GenericFormController;
}());
exports.GenericFormController = GenericFormController;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2VuZXJpY0Zvcm1EaWFsb2cuY29udHJvbGxlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImdlbmVyaWNGb3JtRGlhbG9nLmNvbnRyb2xsZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFLQTtJQU9JLCtCQUNZLGlCQUFzQixFQUN0QixZQUFpQixFQUNqQixrQkFBdUIsRUFDdkIsV0FBeUI7UUFIekIsc0JBQWlCLEdBQWpCLGlCQUFpQixDQUFLO1FBQ3RCLGlCQUFZLEdBQVosWUFBWSxDQUFLO1FBQ2pCLHVCQUFrQixHQUFsQixrQkFBa0IsQ0FBSztRQUN2QixnQkFBVyxHQUFYLFdBQVcsQ0FBYztRQVY5QixpQkFBWSxHQUFZLEtBQUssQ0FBQztRQUM5QixnQkFBVyxHQUFZLElBQUksQ0FBQztRQVcvQixJQUFJLENBQUMsSUFBSSxFQUFFLENBQUM7SUFDaEIsQ0FBQztJQUVELHVDQUFPLEdBQVA7SUFDQSxDQUFDO0lBRU8sb0NBQUksR0FBWjtRQUFBLGlCQVNDO1FBUkcsSUFBSSxDQUFDLEtBQUssR0FBRztZQUNULElBQUksRUFBRSxJQUFJLENBQUMsV0FBVztZQUN0QixPQUFPLEVBQUUsSUFBSSxDQUFDLFdBQVcsQ0FBQyxLQUFLO1NBQ2xDLENBQUM7UUFFRixJQUFJLENBQUMsWUFBWSxDQUFDLEtBQUssQ0FBQyxJQUFJLEVBQUUsVUFBQyxTQUFxQjtZQUNoRCxLQUFJLENBQUMsU0FBUyxHQUFHLFNBQVMsQ0FBQztRQUMvQixDQUFDLENBQUMsQ0FBQztJQUNQLENBQUM7SUFFTSxzQ0FBTSxHQUFiO1FBQUEsaUJBY0M7UUFiRyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxNQUFNLEVBQUU7WUFDbkIsSUFBSSxDQUFDLFdBQVcsR0FBRyxLQUFLLENBQUM7WUFDekIsT0FBTztTQUNWO1FBQ0QsSUFBSSxDQUFDLFdBQVcsR0FBRyxJQUFJLENBQUM7UUFDeEIsSUFBSSxDQUFDLFlBQVksR0FBRyxJQUFJLENBQUM7UUFFekIscURBQXFEO1FBQ3JELElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQyxXQUFXLENBQUM7UUFFbkMsSUFBSSxDQUFDLGtCQUFrQixDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQztZQUN0RCxLQUFJLENBQUMsaUJBQWlCLENBQUMsS0FBSyxFQUFFLENBQUM7UUFDbkMsQ0FBQyxDQUFDLENBQUMsT0FBTyxDQUFDLGNBQU0sT0FBQSxLQUFJLENBQUMsWUFBWSxHQUFHLEtBQUssRUFBekIsQ0FBeUIsQ0FBQyxDQUFDO0lBQ2hELENBQUM7SUFFTSxzQ0FBTSxHQUFiO1FBQ0ksSUFBSSxDQUFDLGlCQUFpQixDQUFDLE9BQU8sRUFBRSxDQUFDO0lBQ3JDLENBQUM7SUFDTCw0QkFBQztBQUFELENBQUMsQUFqREQsSUFpREM7QUFqRFksc0RBQXFCIn0=